/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ViewRequirementFromJSON, ViewRequirementToJSON } from './ViewRequirement';

/**
 * Resource Handler that is registered
 * @export
 * @interface CreateResourceHandler
 */

/**
 * Check if a given object implements the CreateResourceHandler interface.
 */
export function instanceOfCreateResourceHandler(value) {
  if (!('containerRID' in value) || value['containerRID'] === undefined) return false;
  if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
  if (!('handleWith' in value) || value['handleWith'] === undefined) return false;
  return true;
}
export function CreateResourceHandlerFromJSON(json) {
  return CreateResourceHandlerFromJSONTyped(json, false);
}
export function CreateResourceHandlerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'containerRID': json['containerRID'],
    'resourceType': json['resourceType'],
    'handleWith': json['handleWith'],
    'requirements': json['requirements'] == null ? undefined : json['requirements'].map(ViewRequirementFromJSON)
  };
}
export function CreateResourceHandlerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'containerRID': value['containerRID'],
    'resourceType': value['resourceType'],
    'handleWith': value['handleWith'],
    'requirements': value['requirements'] == null ? undefined : value['requirements'].map(ViewRequirementToJSON)
  };
}